import {
  isPlaybookSectionNode,
  type PlaybookNode,
} from "@repo/app-types/entities/playbook";
import type { CannedExchange } from "../../features/copilot/copilotContext.js";

/**
 * The canned conversation Review feedback's Suggest edits action opens Ask
 * Alpharun with. The playbook-node tags reach the model, while the
 * structured-content renderer drops their wrappers and preserves their text.
 */
export function buildFeedbackSuggestionExchange(
  node: PlaybookNode,
): CannedExchange {
  const nodeKind = isPlaybookSectionNode(node) ? "section" : "criteria";
  const playbookNode = `<playbookNode nodeId='${node.id}' nodeType='${nodeKind}'>“${node.name}” ${nodeKind}</playbookNode>`;

  return {
    userText: `Suggest edits to optimize the ${playbookNode} using the feedback as evidence.`,
    replyText: buildFeedbackSuggestionReply(node, nodeKind),
  };
}

function buildFeedbackSuggestionReply(
  node: PlaybookNode,
  nodeKind: "section" | "criteria",
): string {
  const replyNode = `<playbookNode nodeId='${node.id}' nodeType='${nodeKind}'>"${node.name}"</playbookNode>`;

  return `I can get all open feedback for ${replyNode} and use it as evidence to determine how to optimize the ${nodeKind}. I'll draft the smallest coherent changes that address patterns across the feedback without overfitting to any individual call or piece of feedback, validate the proposed changes, and propose them in the editor for your review.

Before I start, is there any additional context or direction you'd like me to consider? If not, just say "Go ahead."`;
}
